export default {"src":"/_next/static/media/logo.a5f4aa5e.svg","height":37,"width":306,"blurWidth":0,"blurHeight":0};